import {
  AppBar,
  Box,
  Button,
  createStyles,

  IconButton,
  makeStyles,


  Theme,
  Toolbar
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { ReactComponent as LogoSvg } from 'assets/icons/btcs-vault-logo.svg';
import { DrawerContextConsumer } from 'contexts/DrawerContext';
import {
  Link,
  useHistory
} from 'react-router-dom';


const useStyles = makeStyles((theme: Theme) => createStyles({
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  appLink: {
    textDecoration: 'none',
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(4),
  },
  logo: {
    height: 43,
    width: 'auto'
  },
  contactButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  loginButton: {
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
}),);


export const BtcsHeader = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <DrawerContextConsumer>
      {({ handleDrawerToggle }) => (
        <AppBar
          color="inherit"
          position="fixed"
          elevation={0}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <Link to="/">
              <LogoSvg className={classes.logo} />
            </Link>
            <Box width="100%" />
            <Button
              component="a"
              href="https://www.bitcoinsuisse.com/contact"
              className={classes.contactButton}
              variant="text"
              size="small"
              flex-shrink={1}
            >
              Contact
            </Button>
            <Button
              component="a"
              href="https://vault.bitcoinsuisse.com/"
              className={classes.loginButton}
              variant="text"
              color="primary"
              size="small"
              flex-shrink={0}
            >
              Login
            </Button>
          </Toolbar>
        </AppBar>
      )}

    </DrawerContextConsumer>
  );
};
